import React from 'react';

const sexIcon = (sex) => {
  if (sex === 'male') return <i className="fas fa-mars text-primary me-1" title="Uomo" style={{fontSize:'14px'}}></i>;
  if (sex === 'female') return <i className="fas fa-venus text-danger me-1" title="Donna" style={{fontSize:'14px'}}></i>;
  return null;
};

const partInfo = (it) => {
  if (!it) return { name: '', email: '' };
  const name = [it.participant?.user?.firstName, it.participant?.user?.lastName].filter(Boolean).join(' ')
    || (it.participantData ? [it.participantData.firstName, it.participantData.lastName].filter(Boolean).join(' ') : '');
  const email = it.participant?.user?.email || it.participantData?.email || it.participantData?.participantEmail || '';
  return { name, email };
};

export default function TransactionTicketGroup({ group, tx, opened, setOpened, fmtDateTime, fmtDate, fmtMoney, shortOrder, isFirst, itemCount, address, cityCap, acquirenteName, acquirenteEmail, utenteName, utenteEmail, handleRefund, refundedCaptureIds }) {
  const firstItem = group.items[0];
  const ticketName = firstItem?.ticketName || '—';
  const noItemsGroup = group.items.length === 0;

  // Se non ci sono items (es. refund transaction senza TransactionItems),
  // rende almeno una riga con placeholders per rendere visibile la transazione
  if (noItemsGroup) {
    return (
      <tr key={`g${group.idx}-empty`} className={opened === tx.id ? 'table-active' : ''}>
        {isFirst && (
          <>
            <td className="bg-warning-subtle text-nowrap ps-4 py-3" rowSpan={1}>
              <button
                className="btn btn-sm btn-light border rounded-circle me-2"
                style={{ width: 28, height: 28, lineHeight: '16px' }}
                onClick={() => setOpened(opened === tx.id ? null : tx.id)}
                title="Dettagli"
              >
                <i className={`bi ${opened === tx.id ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
              </button>
              {fmtDateTime(tx.transactionDate)}
            </td>
            <td className="bg-warning-subtle" rowSpan={1}>
              {tx.type === 'refund' ? (
                <span className="badge bg-danger-subtle text-danger">Rimborso</span>
              ) : (
                <span className="badge bg-success-subtle text-success">Addebito</span>
              )}
              {' '}
              {tx.channel === 'app' ? (
                <span className="badge bg-primary-subtle text-primary" title="Acquisto da app.solteros.it">App</span>
              ) : (
                <span className="badge bg-secondary-subtle text-secondary" title="Acquisto da www.solteros.it">Online</span>
              )}
            </td>
            <td className={`text-end fw-bold ${tx.type === 'refund' ? 'text-danger' : ''}`} rowSpan={1}>
              {tx.type === 'refund' ? '-' : ''}{fmtMoney(tx.amount)}
            </td>
            <td className="bg-warning-subtle text-end text-muted" rowSpan={1}>{fmtMoney(tx.fee)}</td>
            <td className={`text-end fw-bold ${tx.type === 'refund' ? 'text-danger' : ''}`} rowSpan={1}>
              {tx.type === 'refund' ? '-' : ''}{fmtMoney(tx.net)}
            </td>
            <td className="bg-warning-subtle text-muted small text-nowrap" rowSpan={1}>
              {tx.paymentMethod || '—'}
            </td>
            <td className="bg-warning-subtle text-muted small" rowSpan={1}>{shortOrder(tx.referenceOrderId || tx.orderId)}</td>
            <td className="bg-warning-subtle" rowSpan={1}>
              <div className="small fw-semibold text-nowrap">{acquirenteName}</div>
              {acquirenteEmail && acquirenteEmail !== acquirenteName && <div className="text-muted" style={{ fontSize: '11px' }}>{acquirenteEmail}</div>}
            </td>
            <td className="bg-warning-subtle text-muted small" style={{ maxWidth: 160 }} rowSpan={1}>
              <div className="text-truncate" title={address}>{address}</div>
            </td>
            <td className="bg-warning-subtle text-muted small text-nowrap" rowSpan={1}>{cityCap}</td>
            <td className="bg-warning-subtle pe-4" rowSpan={1}>
              {tx.type === 'charge' && tx.captureId && !refundedCaptureIds.has(tx.captureId) ? (
                <button
                  className="btn btn-sm btn-outline-danger rounded-pill"
                  onClick={() => handleRefund(tx)}
                  title="Rimborsa"
                >
                  <i className="bi bi-arrow-return-left me-1"></i>Rimborso
                </button>
              ) : tx.type === 'charge' && refundedCaptureIds.has(tx.captureId) ? (
                <span className="badge bg-danger-subtle text-danger small">Rimborsato</span>
              ) : null}
            </td>

            <td className="bg-info-subtle text-muted small" style={{ maxWidth: 150 }} rowSpan={1}>
              <div className="text-truncate" title={tx.Event?.name || ''}>
                {tx.Event?.name || '—'}
              </div>
            </td>
            <td className="bg-info-subtle text-muted small text-nowrap" rowSpan={1}>{fmtDate(tx.Event?.date)}</td>
            <td className="bg-info-subtle text-muted small text-nowrap" rowSpan={1}>{tx.Event?.city?.name || '—'}</td>
            <td className="bg-info-subtle" rowSpan={1}>
              {utenteName ? (
                <>
                  <div className="small fw-semibold">{utenteName}</div>
                  {utenteEmail && <div className="text-muted" style={{ fontSize: '11px' }}>{utenteEmail}</div>}
                </>
              ) : <span className="text-muted small">—</span>}
            </td>
          </>
        )}

        <td className="bg-success-subtle text-center small fw-semibold" style={{width:'30px'}}>—</td>
        <td className="bg-success-subtle small" style={{ maxWidth: 160 }}>—</td>
        <td className="bg-success-subtle" style={{ maxWidth: 220 }}>
          <div className="text-muted small">Nessun biglietto (rimborso)</div>
        </td>
      </tr>
    );
  }

  return group.items.map((it, i) => {
    const { name: nomName, email: nomEmail } = partInfo(it);
    const isFirstInGroup = i === 0;

    return (
      <tr key={`g${group.idx}-${i}`} className={opened === tx.id ? 'table-active' : ''}>
        {isFirst && isFirstInGroup && (
          <>
            <td className="bg-warning-subtle text-nowrap ps-4 py-3" rowSpan={itemCount}>
              <button
                className="btn btn-sm btn-light border rounded-circle me-2"
                style={{ width: 28, height: 28, lineHeight: '16px' }}
                onClick={() => setOpened(opened === tx.id ? null : tx.id)}
                title="Dettagli"
              >
                <i className={`bi ${opened === tx.id ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
              </button>
              {fmtDateTime(tx.transactionDate)}
            </td>
            <td className="bg-warning-subtle" rowSpan={itemCount}>
              {tx.type === 'refund' ? (
                <span className="badge bg-danger-subtle text-danger">Rimborso</span>
              ) : (
                <span className="badge bg-success-subtle text-success">Addebito</span>
              )}
              {' '}
              {tx.channel === 'app' ? (
                <span className="badge bg-primary-subtle text-primary" title="Acquisto da app.solteros.it">App</span>
              ) : (
                <span className="badge bg-secondary-subtle text-secondary" title="Acquisto da www.solteros.it">Online</span>
              )}
            </td>
            <td className={`text-end fw-bold ${tx.type === 'refund' ? 'text-danger' : ''}`} rowSpan={itemCount}>
              {tx.type === 'refund' ? '-' : ''}{fmtMoney(tx.amount)}
            </td>
            <td className="bg-warning-subtle text-end text-muted" rowSpan={itemCount}>{fmtMoney(tx.fee)}</td>
            <td className={`text-end fw-bold ${tx.type === 'refund' ? 'text-danger' : ''}`} rowSpan={itemCount}>
              {tx.type === 'refund' ? '-' : ''}{fmtMoney(tx.net)}
            </td>
            <td className="bg-warning-subtle text-muted small text-nowrap" rowSpan={itemCount}>
              {tx.paymentMethod || '—'}
            </td>
            <td className="bg-warning-subtle text-muted small" rowSpan={itemCount}>{shortOrder(tx.referenceOrderId || tx.orderId)}</td>
            <td className="bg-warning-subtle" rowSpan={itemCount}>
              <div className="small fw-semibold text-nowrap">{acquirenteName}</div>
              {acquirenteEmail && acquirenteEmail !== acquirenteName && <div className="text-muted" style={{ fontSize: '11px' }}>{acquirenteEmail}</div>}
            </td>
            <td className="bg-warning-subtle text-muted small" style={{ maxWidth: 160 }} rowSpan={itemCount}>
              <div className="text-truncate" title={address}>{address}</div>
            </td>
            <td className="bg-warning-subtle text-muted small text-nowrap" rowSpan={itemCount}>{cityCap}</td>
            <td className="bg-warning-subtle pe-4" rowSpan={itemCount}>
              {tx.type === 'charge' && tx.captureId && !refundedCaptureIds.has(tx.captureId) ? (
                <button
                  className="btn btn-sm btn-outline-danger rounded-pill"
                  onClick={() => handleRefund(tx)}
                  title="Rimborsa"
                >
                  <i className="bi bi-arrow-return-left me-1"></i>Rimborso
                </button>
              ) : tx.type === 'charge' && refundedCaptureIds.has(tx.captureId) ? (
                <span className="badge bg-danger-subtle text-danger small">Rimborsato</span>
              ) : null}
            </td>

            <td className="bg-info-subtle text-muted small" style={{ maxWidth: 150 }} rowSpan={itemCount}>
              <div className="text-truncate" title={tx.Event?.name || ''}>
                {tx.Event?.name || '—'}
              </div>
            </td>
            <td className="bg-info-subtle text-muted small text-nowrap" rowSpan={itemCount}>{fmtDate(tx.Event?.date)}</td>
            <td className="bg-info-subtle text-muted small text-nowrap" rowSpan={itemCount}>{tx.Event?.city?.name || '—'}</td>
            <td className="bg-info-subtle" rowSpan={itemCount}>
              {utenteName ? (
                <>
                  <div className="small fw-semibold">{utenteName}</div>
                  {utenteEmail && <div className="text-muted" style={{ fontSize: '11px' }}>{utenteEmail}</div>}
                </>
              ) : <span className="text-muted small">—</span>}
            </td>
          </>
        )}

        <td className="bg-success-subtle text-center small fw-semibold" style={{width:'30px'}}>
          {isFirstInGroup ? (firstItem?.participantData?.ticketQty ?? 1) : ''}
        </td>
        <td className="bg-success-subtle small" style={{ maxWidth: 160 }}>
          {isFirstInGroup ? ticketName : ''}
        </td>
        <td className="bg-success-subtle" style={{ maxWidth: 220 }}>
          <div className="d-flex align-items-center gap-2">
            {sexIcon(it?.sex)}
            <div>
              <div className="small fw-semibold">{nomName || '—'}</div>
              {nomEmail && <div className="text-muted" style={{ fontSize: '11px' }}>{nomEmail}</div>}
            </div>
          </div>
        </td>
      </tr>
    );
  });
}